export default {
    newDesign: true,
    parameters: {
        landing_id: "BrQMine",
        segment: 42,
        success_page: "success_long",
    },
    title:
        "Responda a algumas perguntas rápidas para ter acesso à sua aula experimental gratuita | Kodland",
    downtimeUrl: "https://www.kodland.org/pt",
    startPage: {
        title:
            "Responda a algumas perguntas rápidas para ter acesso à sua aula experimental gratuita.",
        image: {
            url: "/welcome/brazil_mine_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/brazil_mine_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "🚀 Começar o quiz",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Obrigado por confiar em nossa plataforma educacional!",
        subtitle:
            "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
    },
    customStopPages: {
        child: {
            title: "Infelizmente, apenas um pai, mãe ou responsável pode inscrever um aluno nas aulas.",
            subtitle:
                "Se quiser continuar, você pode compartilhar este link com seus pais. Esperamos te ver em nossas aulas em breve!",
            image: "/welcome/quizV2/child-parent.png",
        },
    },
    quizRotateBySteps: {
        1: {
            question: "Você é mãe, pai, outro familiar ou filho(a)?",
            answers: [
                "👨‍🦱 Sou pai",
                "👩‍🦰 Sou mãe",
                {
                    answer: "👧🧒 Sou filho(a)",
                    stopAnswer: true,
                    customStopPageId: "child",
                },
                
            ],
        },
        2: {
            question: "Como você descreveria a personalidade do seu filho ou filha?",
            subtitle: "Isso nos ajuda a escolher o melhor estilo de ensino.",
            answers: [
                "🐶 Energético(a) e comunicativo(a)",
                "🌙 Sonhador(a) e imaginativo(a)",
                "🤔 Ainda está descobrindo do que gosta",
                "😳 Tímido(a)",
                "🌱 Calmo(a) e prefere atividades individuais",
            ],
        },
        3: {
            question: "O que você gostaria que seu filho ou filha aprendesse com o curso?",
            answers: [
                "🎮 Se divertir enquanto aprende",
                "👩‍💻 Aprender habilidades tecnológicas reais",
                "🧠 Melhorar o foco e a disciplina",
                "📱 Usar o tempo de tela de forma mais produtiva",
                "🍀 Descobrir o que gosta de fazer",
                "💬 Desenvolver criatividade e comunicação",
            ],
        },
        4: {
            question:
                "Você tem um computador de mesa ou notebook com o qual seu filho pode estudar?",
            answers: [
                "💻 Sim",
                {
                    answer: "😞 Não",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            title: "Quantos anos tem seu filho/a?",
            type: "age",
            button: "",
        },
        6: {
            title: "Inscreva-se em uma aula experimental",
            type: "one-page-contacts",
            subtitle:
                "Veja como seu filho pode começar a programar com a nossa ajuda.",
            button: "Quase lá! 🔥",
        },
        7: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        8: {
            title: "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
            typeInfo: "pc-laptop",
            subtitle:
                "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
            button: "O que mais?",
        },
        9: {
            title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
            button: "O que mais?",
        },
        10: {
            title: "A aula vai acontecer na nossa plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
            button: "Entendi ✅",
        },
    },
};
